import React from 'react';

import { Icons } from '@/src/assets/icons';
import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import ModalPortal from '@/src/components/common/Modal/ModalPortal';
import { useLibraryListStore } from '@/src/components/project/Library/store/library-list.store';
import { useToggle } from '@/src/hooks/useToggle';

import FoldersModal from './MoveFiles/FoldersModal';

const Move = ({ itemIdsVersioned, shouldResetSelected = true }) => {
  const [isModalOpen, toggleIsModalOpen] = useToggle(false);
  const showUndoToast = useLibraryListStore((s) => s.showUndoToast);

  const handleToggleMove = async () => {
    toggleIsModalOpen();
  };

  const handleMoved = (undoData) => {
    showUndoToast({
      itemIdsVersioned: undoData.itemIdsVersioned,
      previousParentId: undoData.previousParentId,
    });
  };

  return (
    <React.Fragment>
      <a
        onClick={handleToggleMove}
        data-tooltip-id={`actionItem_${itemIdsVersioned.toString()}_singleMove`}
      >
        <i className="moveIcon">{Icons.MoveFilesIcon}</i>
        <Tooltip
          id={`actionItem_${itemIdsVersioned.toString()}_singleMove`}
          place="bottom"
          effect="solid"
        >
          Move
        </Tooltip>
      </a>
      {isModalOpen && (
        <ModalPortal>
          <FoldersModal
            onClose={toggleIsModalOpen}
            itemIdsVersioned={itemIdsVersioned}
            shouldResetSelected={shouldResetSelected}
            onMoved={handleMoved}
          />
        </ModalPortal>
      )}
    </React.Fragment>
  );
};

export default Move;
